import { render } from "./ImageClickPosition.vue?vue&type=template&id=3b7f0582&scoped=true"
import script from "./ImageClickPosition.vue?vue&type=script&lang=js"
export * from "./ImageClickPosition.vue?vue&type=script&lang=js"

import _style_0 from "./ImageClickPosition.vue?vue&type=style&index=0&id=3b7f0582&inline&scoped=true&lang=css"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-3b7f0582"]])

export default __exports__